module.exports = __webpack_public_path__ + "static/media/tick.3321343f.svg";